
































import Component, { mixins } from "vue-class-component";
import BlockBase from "@/components/BlockBase.vue";
import { Prop } from "vue-property-decorator";
import { FormValues } from "@/types";
import FormatMoney from "@/components/FormatMoney";
import PaymentPackageEditForm from "@/views/PagePricing/components/PaymentPackageEditForm.vue";
import PaymentPackageMixin from "@/views/PagePricing/mixins/paymentPackageMixin";
import BaseLabel from "@/components/BaseLabel.vue";
import { getCurrencySymbol } from "@/lib/helpers/money";
import {
  PaymentPackage,
  CurrencyCost,
  InputPaymentPackageUpdate,
} from "@teacherskaya/api-provider/dist/api/PaymentPackageProvider";
import { Currency } from "@teacherskaya/api-provider/dist/api/CurrencyProvider";

@Component({
  name: "BlockPaymentPackage",
  components: { BaseLabel, PaymentPackageEditForm, FormatMoney, BlockBase },
})
export default class BlockPaymentPackage extends mixins(PaymentPackageMixin) {
  @Prop({ type: Object, required: true })
  public readonly paymentPackage!: PaymentPackage;

  @Prop({ type: Array, required: true })
  public readonly currencyList!: Currency[];

  @Prop({ type: Boolean, default: false })
  public readonly hideCosts!: boolean;

  public editing: boolean = false;

  get costData(): CurrencyCost[] {
    return (
      (this.paymentPackage &&
        this.paymentPackage.costs.map(item => {
          return {
            currency: item.currency ? getCurrencySymbol(item.currency) : "",
            cost: item.cost,
          };
        })) ||
      []
    );
  }

  public save(values: FormValues) {
    const data: InputPaymentPackageUpdate = {
      id: this.paymentPackage.id,
      name: values.name || "",
      amount: values.amount && Number(values.amount) > 0 ? Number(values.amount) : Number(values.cost),
      costs: values.costs || [],
    };
    this.$emit("update", { data, type: this.paymentPackage.type });
    this.editing = false;
  }

  public cancel() {
    this.editing = false;
  }

  public deleteItem() {
    const packageId = this.paymentPackage.id;
    this.$emit("delete", { packageId });
  }
}
